var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.5 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 52v-7.85l-.99-1.35-3.63 5.96-.78-1.26h-3.8v4.5h-21.4v-14.2h2.5v-19.1h-2.5v-13.61l5.1-5.09h16.68l7.77 12.94 4.83-8.03 4.93-4.91h17.19v14.2h-2.6v19.1h2.6v14.16l-4.53 4.54z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m55.4 13.1v-12h-15.62l-4.5 4.48-5.73 9.56-8.42-14h-15.56l-4.47 4.42v12h2.5v21.34h-2.5v12h19.2v-4.5h4.5v-1.8l1.18 2 3.61-6 .9 1.45 1.21-2v10.85h19.57l4.13-4.14v-12.36h-2.6v-21.3z",
    className: "cjd-stroke",
    fill: "#8089a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30.46 39.88-9.4-15.54v11.15h2.58v9.71h-17v-9.71h2.59v-23.6h-2.58v-9.7h13.84l10 16.62 10-16.62h13.77v9.7h-2.58v23.6h2.58v9.71h-17v-9.71h2.58v-11.15z",
    className: "cjd-fill",
    fill: "#f9fbfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/m.7f60bc0b707f81fadeb0877f1458d6dd.svg";
export { ForwardRef as ReactComponent };